import multiApiClient from "./base";

export const HealthApi = {
  getReport: () => multiApiClient.get("/health/report"),

  runBuyPriceAudit: ({
    days = 3,
    max_hours_after_base_run = 48,
    limit = 50,
    external_verify_limit = 0,
  } = {}) =>
    multiApiClient.post("/health/audit/buy-price", null, {
      params: { days, max_hours_after_base_run, limit, external_verify_limit },
    }),

  getCronStatus: () => multiApiClient.get("/health/cron/status"),

  updateCronConfig: ({
    schedule = null,
    days = 3,
    max_hours_after_base_run = 48,
    external_verify_limit = 0,
    discord_webhook = "",
    notify_on_nonzero = true,
  } = {}) =>
    multiApiClient.post("/health/cron/config", null, {
      params: {
        ...(schedule ? { schedule } : {}),
        days,
        max_hours_after_base_run,
        external_verify_limit,
        ...(discord_webhook ? { discord_webhook } : {}),
        notify_on_nonzero,
      },
    }),
};
